/**
 * External dependencies
 */
import { AxiosInstance, AxiosResponse } from 'axios';

/**
 * Internal dependencies
 */
import Header from '@naruto/naruto-api/src/tools/Header';
import BaseAPI from '@naruto/naruto-api/src/base';
import { BaseResponse } from './types';

class ContactAPI extends BaseAPI {
  constructor({ axios, header }: { axios: AxiosInstance; header: Header }) {
    super({ axios, header });
  }

  /* ======== API: site meta ======== */
  async getContactInfo<Response, Params = undefined>(params?: Params): Promise<BaseResponse<Response>> {
    try {
      const res = await this.axios.get<Params, AxiosResponse<Response>>('/api/admin/contact', {
        headers: { ...this.header.header },
        params
      });
      return { response: res.data, status: res.status, headers: res.headers };
    } catch (error) {
      const responseData = this.generatorAPIError(error) as BaseResponse<Response>;
      return responseData;
    }
  }

  async putContact<Response, Body = undefined>(body: Body): Promise<BaseResponse<Response>> {
    try {
      const res = await this.axios.put<Body, AxiosResponse<Response>>('/api/admin/contact', body, {
        headers: { ...this.header.header }
      });
      return { response: res.data, status: res.status, headers: res.headers };
    } catch (error) {
      const responseData = this.generatorAPIError(error) as BaseResponse<Response>;
      return responseData;
    }
  }
}

export default ContactAPI;
